// extracted by mini-css-extract-plugin
export var actions = "_1a-0";
export var actionsContainer = "_1a-8";
export var border = "_1a-1";
export var childFullHeight = "_1a-f";
export var collapse = "_1a-2";
export var content = "_1a-a";
export var contentChild = "_1a-e";
export var fullscreen = "_1a-c";
export var hasLeftRadius = "_1a-r";
export var headerContainer = "_1a-3";
export var headerRow = "_1a-5";
export var hidePadding = "_1a-b";
export var navCollapsedGap = "_1a-s";
export var noScrollX = "_1a-t";
export var noScrollY = "_1a-u";
export var noTopPadding = "_1a-p";
export var optOutTopPadding = "_1a-d";
export var outletContent = "_1a-l";
export var outletContentInner = "_1a-m";
export var outletLeadingPanel = "_1a-i";
export var outletLeadingPanelAttention = "_1a-j";
export var outletNoScroll = "_1a-7";
export var outletResizeDivider = "_1a-k";
export var outletSplit = "_1a-g";
export var outletSplitResizing = "_1a-h";
export var pageMain = "_1a-q";
export var pageOuter = "_1a-n";
export var pagePadding = "_1a-9";
export var profile = "_1a-v";
export var profileContainer = "_1a-w";
export var profileImage = "_1a-x";
export var profileMain = "_1a-y";
export var profileSubtitle = "_1a-10";
export var profileTitle = "_1a-z";
export var showLeftPadding = "_1a-o";
export var tabsPortalSlot = "_1a-6";
export var tabsWrapper = "_1a-4";
export var title = "_1a-11";